<template>
  <article class="prose dark:prose-invert mx-auto">
    <UpmSkeletonWrapper v-if="isLoading">
      <UpmSkeleton class="mb-8 h-8 w-48 max-w-full" />
      <div class="space-y-2.5">
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4 w-[96%]" />
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4 w-2/3" />
      </div>

      <div class="mt-8 space-y-2.5">
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4 w-10/12" />
      </div>

      <div class="mt-8 space-y-2.5">
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4" />
        <UpmSkeleton class="h-4 w-[96%]" />
        <UpmSkeleton class="h-4 w-1/5" />
      </div>
    </UpmSkeletonWrapper>

    <Transition
      enter-active-class="transform ease-out duration-500 transition"
      enter-from-class="-translate-y-2 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
    >
      <UpmMarkdown v-if="!isLoading" tag="div">{{ terms }}</UpmMarkdown>
    </Transition>
  </article>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useApi, useApiUrl, useErrorHandler } from "@src/composables/api";
import UpmMarkdown from "@src/components/UpmMarkdown.vue";
import UpmSkeletonWrapper from "@src/components/UpmSkeletonWrapper.vue";
import UpmSkeleton from "@src/components/UpmSkeleton.vue";

const isLoading = ref(false);
const terms = ref("");
const { useApiGet } = useApi();

const init = async () => {
  isLoading.value = true;
  try {
    // Construct the terms URL
    const url = useApiUrl("terms_and_conditions/current");
    const { data: response } = await useApiGet({ url });
    terms.value =
      response.data?.terms?.terms_translated ||
      response.data?.terms?.terms ||
      "";
  } catch (e) {
    useErrorHandler(e);
  } finally {
    isLoading.value = false;
  }
};

init();
</script>
